import type { JourneyBuilderState } from './state';


export function setEligibleNodeConnections(
  state: JourneyBuilderState,
  action: { payload: JourneyBuilderState['eligibleNodeConnections'] },
) {
  state.eligibleNodeConnections = action.payload;
}

export function setMultiEntity(
  state: JourneyBuilderState,
  action: { payload: JourneyBuilderState['isMultiEntity'] },
) {
  state.isMultiEntity = action.payload;
}

export function setNodeConnectionType(
  state: JourneyBuilderState,
  action: { payload: JourneyBuilderState['nodeConnectionType'] },
) {
  state.nodeConnectionType = action.payload;
}

export function setOverlappingEdges(
  state: JourneyBuilderState,
  action: { payload: JourneyBuilderState['overlappingEdges'] },
) {
  state.overlappingEdges = action.payload;
}

export function setOverlappingNodes(
  state: JourneyBuilderState,
  action: { payload: JourneyBuilderState['overlappingNodes'] },
) {
  state.overlappingNodes = action.payload;
}

export function setShouldLayout(
  state: JourneyBuilderState,
  action: { payload: JourneyBuilderState['shouldLayout'] },
) {
  state.shouldLayout = action.payload;
}

export function setShowValidationErrors(
  state: JourneyBuilderState,
  action: { payload: JourneyBuilderState['showValidationErrors'] },
) {
  state.showValidationErrors = action.payload;
}

export function setJourney(
  state: JourneyBuilderState,
  action: { payload: JourneyBuilderState['journey'] },
) {
  state.journey = action.payload;
}

export function setEdgesQueue(
  state: JourneyBuilderState,
  action: { payload: JourneyBuilderState['edgesQueue'] },
) {
  state.edgesQueue = action.payload;
}

export function setNodesQueue(
  state: JourneyBuilderState,
  action: { payload: JourneyBuilderState['nodesQueue'] },
) {
  state.nodesQueue = action.payload;
}
